import React from 'react';
import '../static/styles/show-detail.scss';

interface Props {
	show: boolean,
	showDetail: () => void
}

interface State {
}

class ShowDetail extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
	}

	render() {
		return (
			<div className="show-detail-root" style={{display: this.props.show ? "flex" : "none"}}>
				<div className="content" onClick={this.props.showDetail}>
					<span>查看更多</span>
					<img src={process.env.PUBLIC_URL + "/image/arrow-down.svg"}/>
				</div>
			</div>
		)
	}
}

export default ShowDetail;
